import Immutable from 'seamless-immutable';

import actions from './actions';

const initState = Immutable.from({
	settings_st: []
});

export default function settingsStReducer(state = initState, { type, payload }) {
	switch (type) {
		case actions.SETTINGS_ST_SET: {
			return Immutable.set(state, 'settings_st', payload.settings_st);
		}
		default: {
			return state;
		}
	}
}
